module.exports = __webpack_public_path__ + "static/media/cleaning.337613e5.svg";